import { AllRoutes, AnyRoute } from 'constants/routes';
import { JSX } from 'react';
import { ReactComponent as AssessmentEditorIcon } from 'icons/sidenav-icons/assessment-editor.svg';
import { ReactComponent as CoreMeasuresIcon } from 'icons/sidenav-icons/core-measures.svg';
import { ReactComponent as FacilityLibraryIcon } from 'icons/sidenav-icons/facility-library.svg';
import { ReactComponent as FacilityUserAccountsIcon } from 'icons/sidenav-icons/facility-user-accounts.svg';
import { ReactComponent as GroupTherapyIcon } from 'icons/sidenav-icons/group-therapy-sessions.svg';
import { ReactComponent as HelpIcon } from 'icons/sidenav-icons/help.svg';
import { ReactComponent as PatientAccountsIcon } from 'icons/sidenav-icons/patient-accounts.svg';
import { ReactComponent as PrintableAssessmentsIcon } from 'icons/sidenav-icons/printable-assessments.svg';
import { ReactComponent as ReferencesIcon } from 'icons/sidenav-icons/references.svg';
import { ReactComponent as ReportsIcon } from 'icons/sidenav-icons/reports.svg';
import { ReactComponent as X } from 'icons/sidenav-icons/close-x.svg';
import { ReactComponent as Home } from 'icons/sidenav-icons/home.svg';
import { TFunction } from 'i18next';
import { GetNavText } from './navOptions';

export const getNavIcon = (route: AnyRoute, isUHS: boolean, t: TFunction): JSX.Element => {
  const iconTitle = GetNavText(route, isUHS, t);
  switch (route) {
    default:
      return <X title={route.toString()} className="sidenav-icon" />;
    case AllRoutes.ASSESSMENT_EDITOR:
      return <AssessmentEditorIcon title={iconTitle} className="sidenav-icon" />;
    case AllRoutes.DASHBOARD:
      return <Home title={iconTitle} className="sidenav-icon" />;
    case AllRoutes.HELP:
      return <HelpIcon title={iconTitle} className="sidenav-icon" />;
    case AllRoutes.FACILITY_LIBRARY:
      return <FacilityLibraryIcon title={iconTitle} className="sidenav-icon" />;
    case AllRoutes.PATIENT_ACCOUNTS:
      return <PatientAccountsIcon title={iconTitle} className="sidenav-icon" />;
    case AllRoutes.GROUP_THERAPY_BASE:
      return <GroupTherapyIcon title={iconTitle} className="sidenav-icon" />;
    case AllRoutes.PRINTABLE_ASSESSMENTS:
      return <PrintableAssessmentsIcon title={iconTitle} className="sidenav-icon" />;
    case AllRoutes.REPORTS:
    case AllRoutes.ADMIN_REPORTS:
      return <ReportsIcon title={iconTitle} className="sidenav-icon" />;
    case AllRoutes.FACILITY_USER_ACCOUNTS:
      return <FacilityUserAccountsIcon title={iconTitle} className="sidenav-icon" />;
  }
};

export const getSubmenuIcon = (submenuTitle: string): JSX.Element => {
  switch (submenuTitle) {
    default:
      return <X title={submenuTitle} className="sidenav-icon" />;
    case 'References':
      return <ReferencesIcon title="References" className="sidenav-icon" />;
    case 'Core Measures':
      return <CoreMeasuresIcon title="Core Measures" className="sidenav-icon" />;
  }
};
